import React from 'react';
import { Image } from '@blueprint/image';
import { GalleryImage } from 'shared/components/Gallery/Gallery.types';

import ImagePlaceholder from 'public/assets/image-placeholder.svg';
import { ListingImageContainer } from './ListingImagePreview.styles';

type ListingImageProps = {
    image?: GalleryImage;
    compact?: boolean;
};

const ListingImagePreview = ({ image, compact = false }: ListingImageProps) => {
    return (
        <ListingImageContainer isCompact={compact}>
            {image ? (
                <Image
                    role="img"
                    src={image.src}
                    responsiveImgList={image.responsiveImgList?.original}
                />
            ) : (
                <img
                    width="90"
                    src={ImagePlaceholder}
                    role="presentation"
                    loading="lazy"
                />
            )}
        </ListingImageContainer>
    );
};

export default ListingImagePreview;
